import { memoizeByAssetSource } from '@exodus/core-selectors/utils/memoize.js';
import { createSelector } from 'reselect';
const selectorFactory = (availableAssetsSelector, createAssetSourceIncomingOrdersSelector) => memoizeByAssetSource(({ assetName, walletAccount }) => createSelector(createAssetSourceIncomingOrdersSelector({ assetName, walletAccount }), availableAssetsSelector, (incomingOrders, availableAssets) => {
    if (!availableAssets[assetName]) {
        throw new Error('cannot use use selector on unavailable asset');
    }
    const asset = availableAssets[assetName];
    const currency = asset.currency;
    const zero = currency.ZERO ?? currency.defaultUnit(0);
    return [...incomingOrders].reduce((acc, next) => {
        if (!next.toAmount)
            return acc;
        return acc.add(next.toAmount);
    }, zero);
}));
const createAssetSourceIncomingOrdersAmountSelectorDefinition = {
    id: 'createAssetSourceIncomingOrdersAmount',
    selectorFactory,
    dependencies: [
        { module: 'availableAssets', selector: 'all' },
        { selector: 'createAssetSourceIncomingOrders' },
    ],
};
export default createAssetSourceIncomingOrdersAmountSelectorDefinition;
